import React, { Component } from 'react';

import Section from './Section';

require(`../assets/${process.env.PAGE}/css/components/photo-register.css`);

const SelfieWithDocumentIntroduction = ({ onFinish }) => {
  return (<div style={{
    position: "relative",
    display: "block",
    width: "100%",
    height: "100%",
    overflowY: "scroll",
    background: "#0a2540",
  }}>
    <Section className="intro_form">
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12 text-center">
          <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)} />
        </div>
        <div className="col-sm-10 col-md-10 col-lg-10 col-sm-offset-1 col-md-offset-1 col-lg-offset-1 text-center selfie-message" style={{ marginTop: "50px; !important" }}>
          <h4><b>Necesitamos una selfie con tu DNI en mano. Tal como figura en la imagen.</b></h4>
        </div>
        <div className="col-sm-10 col-md-10 col-lg-10 col-sm-offset-1 col-md-offset-1 col-lg-offset-1 text-center">                <div className="col-sm-10 col-md-10 col-lg-8 col-sm-offset-1 col-md-offset-1 col-lg-offset-2 text-center dni-img-container">
          <img alt="Selfie con instrucciones" src={require(`../assets/common/photo-identity/selfie-document-instructions.png`)} />
        </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12 text-center">
            <button
              type="submit"
              className="btn btn-warning btn-lg pd-button pd-form"
              onClick={(event) => {
                event.preventDefault();
                onFinish();
              }}>
              Entendido
            </button>
          </div>
        </div>
      </div>
    </Section>
  </div>)
}

module.exports = SelfieWithDocumentIntroduction;



/** WEBPACK FOOTER **
 ** ./src/components/SelfieWithDocumentIntroduction.js
 **/